<template>
  <NotificationTemplate
    v-if="notification.content.hasUnfinishedItems"
    :notification="notification"
    :projectName="notification.projectName"
    :showSubTitle="false"
    class="notification__milestone-completed"
  >
    <template #pic>
      <div class="label-pic is-red-notification">
        <icon
          data="@icon/milestoneIcon.svg"
          class="label-pic__icon"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
      </div>
    </template>
    <template #title>
      <div class="notification-title-flex">
        <BaseSubHeading
          size="large"
          color="monochrome-06"
          darkColor="monochrome-03"
          weight="500"
          class="header-text"
        >
          Milestone reached its <br />deadline.
        </BaseSubHeading>
        <BaseSubHeading
          size="small"
          color="monochrome-05"
          darkColor="monochrome-04"
          weight="500"
          class="project-setcion"
        >
          {{ notification.projectName }}
        </BaseSubHeading>
      </div>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="500"
      >
        Not planned work was completed.
      </BaseSubHeading>
    </template>
    <template #content>
      <div className="notification__update-item__content">
        <a
          :href="notification.url"
          class="link is-medium-500"
          target="_blank"
        >
          {{ notification.milestoneName }}
        </a>
        <BaseSubHeading
          size="medium"
          color="monochrome-07"
          weight="500"
        >
          {{ notification.milestoneDate }}
        </BaseSubHeading>
      </div>
      <BaseSubHeading
        size="medium"
        color="serviceAlert-02"
        weight="500"
        class="days-info-container"
      >
        {{ notification.daysLeft }} Days Left, {{ notification.percentComplete }}% Done
      </BaseSubHeading>
      <BaseSubHeading
        v-if="notification.currentGoalContent"
        size="medium"
        color="monochrome-07"
        darkColor="monochrome-03"
        weight="400"
      >
        {{ notification.currentGoalContent }}
      </BaseSubHeading>
    </template>
  </NotificationTemplate>

  <GOAL_REACHED
    v-else
    :notification="notification"
  />
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import GOAL_REACHED from "@/components/Notification/NotificationByType/GOAL_REACHED.vue"
import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { NotificationMilestone } from "@/models/Notification"

@Options({
  name: "MILESTONE_AT_RISK",
  components: {
    NotificationTemplate,
    GOAL_REACHED
  }
})
export default class MILESTONE_AT_RISK extends Vue {
  @Prop() readonly notification: NotificationMilestone
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/utils/mixins/_flex";

.dark {
  .notification__milestone-completed {
    border-bottom: 1px solid var(--markingRed-03);
    background: var(--markingRed-05);
  }
}

.notification__milestone-completed {
  border-bottom: 1px solid var(--markingRed-01);
  background: var(--markingRed-00);
}

.notification-title-flex {
  @include flex($justify: space-between, $align: normal);

  gap: 4px;
}

.notification__update-item__content {
  padding-top: var(--step2);
}

.header-text {
  padding-top: var(--step1);
}

.project-setcion {
  padding-top: 6px;
}

.days-info-container {
  padding-bottom: var(--step1);
}

.notification__milestone-completed :deep(.notification__header) {
  align-items: normal;
}
</style>
